import { useContext, type ComponentProps, type ReactNode } from "react";
import { Button, Flex, FlexItem, Loading, Small } from "orcs-design-system";
import { components } from "react-select";
import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import PropTypes from "prop-types";
import { SelectorContext } from "../contexts/selectorContext";

const StyledContainer = styled.div`
  background: ${themeGet("colors.surface")};
  &:hover {
    background: #d2eeff;
  }
`;

const MultiValueRemove = () => {
  return null;
};

export const CustomMenuList = ({
  children,
  ...rest
}: {
  children?: ReactNode;
  [key: string]: unknown;
}) => {
  const { createNewTag, loadMoreLoading, allowCreateNewTag } =
    useContext(SelectorContext);

  const onCreateNewTag = (event) => {
    event.stopPropagation();
    createNewTag?.();
  };

  return (
    <>
      {allowCreateNewTag && (
        <StyledContainer onClick={onCreateNewTag}>
          <Flex
            justifyContent="space-between"
            alignItems="center"
            p="s"
            gap="s"
          >
            <FlexItem flex="1 1 auto">
              <Small>Missing a tag?</Small>
            </FlexItem>
            <FlexItem flex="0 0 auto">
              <Button
                type="button"
                onClick={onCreateNewTag}
                small
                variant="success"
              >
                Create new tag
              </Button>
            </FlexItem>
          </Flex>
        </StyledContainer>
      )}
      <components.MenuList
        {...(rest as unknown as ComponentProps<typeof components.MenuList>)}
      >
        {children}
        {loadMoreLoading && <Loading centered />}
      </components.MenuList>
    </>
  );
};

CustomMenuList.propTypes = {
  children: PropTypes.node,
};

export default { MultiValueRemove };
